import '../styles/IntegrationsMasthead.css';
import React from 'react';

function IntegrationsMasthead() {
  return (
    <section className="im-mast" aria-labelledby="im-mast-title">
      <div className="im-mast__rail" data-content-rail="workspace">
        <div className="im-mast__grid">
          <div className="im-mast__copy">
            <p className="im-mast__eyebrow">Brute · Admin workspace</p>
            <h1 className="im-mast__title" id="im-mast-title">
              INTEGRATIONS
              <span className="im-mast__title-rule" aria-hidden="true" />
            </h1>
            <p className="im-mast__subline">
              Authorized external services over <code>REST APIs</code> — configured locally, contacted
              only when authorized.
            </p>
          </div>

          <div className="im-mast__sticker-col">
            <span className="im-mast__sticker">
              <span className="im-mast__sticker-dot" aria-hidden="true" />
              <span className="im-mast__sticker-text">
                AUTHORIZED TARGET ONLY
                <span className="im-mast__sticker-line">ETHICAL LOCK · ALWAYS ON</span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default IntegrationsMasthead;